import { Injectable, EventEmitter } from "@angular/core";
import { Subscription } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class ValidationService {
  clearInputs = new EventEmitter();
  subsVar: Subscription;
  constructor() {}

  clear() {
    this.clearInputs.emit();
  }
}
